// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6JK3P","index":"styles_index__2x35G"};